import React, { Component } from 'react';
import CacheKeys from '../../../cache/CacheKeys';
import CacheManager from '../../../cache/CacheManager';
import LeadListPageUI from './LeadListPageUI.js';

class LeadListPageSf extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errorList: null,
      leadList: null,
      selectedLead: null,
      copyToClipboardText: null,
      emailToLeadMode: false,
      createLeadMode: false,
      leadUpdateMode: false,
      sendCustomEmailMode: false,
      salesChannelList: [],
      ownerUserList: [],
      supportOwnerUserList: [],
    };
  }

  render() {
    return (
      <LeadListPageUI
        context={this.props.context}
        onRowClick={this.onRowClick}
        errorList={this.state.errorList}
        leadList={this.state.leadList}
        selectedLead={this.state.selectedLead}
        onRefreshClick={this.onRefreshClick}
        copyToClipboardText={this.state.copyToClipboardText}
        onCopyToClipboard={this.onCopyToClipboard}
        //
        createLeadMode={this.state.createLeadMode}
        onCreateLeadClick={() => { this.setState({ createLeadMode: true }) }}
        onCreateLeadCancel={this.onCreateLeadCancel}
        //
        leadUpdateMode={this.state.leadUpdateMode}
        onLeadUpdateClick={this.onLeadUpdateClick}
        onCancelLeadUpdate={this.onCancelLeadUpdate}
        //
        emailToLeadMode={this.state.emailToLeadMode}
        onSendEmailToLeadClick={() => { this.setState({ emailToLeadMode: true }) }}
        onCancelEmailToLead={this.onCancelEmailToLead}
        //
        sendCustomEmailMode={this.state.sendCustomEmailMode}
        onSendCustomEmailClick={this.onSendCustomEmailClick}
        onSendCustomEmailCancel={this.onSendCustomEmailCancel}
        //
        salesChannelList={this.state.salesChannelList}
        ownerUserList={this.state.ownerUserList}
        supportOwnerUserList={this.state.supportOwnerUserList}
      />
    );
  }

  componentDidMount() {
    let context = this.props.context;
    this.getAllLeads(context);
    this.getSalesChannels(context);
    this.getOwnerUsers(context);
    this.getSupportOwnerUsers(context);
  }

  getAllLeads(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/leads`,
      cacheKey: CacheKeys.Leads(),
      callback: this.getAllLeadsCallback,
      ttlInSecs: 600,
    });
    cacheManager.getObject2(context);
  }

  getAllLeadsCallback = (response) => {
    this.setState({ leadList: response.leadList });
  };

  getSalesChannels(context) {
    let cacheManager = new CacheManager({
      resource: `/api/reference/salesChannels`,
      cacheKey: CacheKeys.SalesChannel(),
      callback: this.getSalesChannelsCallback,
      ttlInSecs: 600
    });
    cacheManager.getObject2(context);
  }

  getSalesChannelsCallback = (response) => {
    let salesChannelList = response.salesChannelList.map(channel => ({
      key: channel.code,
      value: channel.name
    }));
    this.setState({ salesChannelList: salesChannelList });
  };

  getOwnerUsers(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/superusers`,
      cacheKey: CacheKeys.OwnerUsers(),
      callback: this.getOwnerUsersCallback,
      ttlInSecs: 600
    });
    cacheManager.getObject2(context);
  }

  getOwnerUsersCallback = (response) => {
    let ownerUserList = response.userList.map(user => ({
      key: user.userId,
      value: user.addressableName
    }));
    this.setState({ ownerUserList:ownerUserList });
  };

  getSupportOwnerUsers(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/superusers`,
      cacheKey: CacheKeys.SupportOwnerUsers(),
      callback: this.getSupportOwnerUsersCallback,
      ttlInSecs: 600
    });
    cacheManager.getObject2(context);
  }

  getSupportOwnerUsersCallback = (response) => {
    let supportOwnerUserList = response.userList.map(user => ({
      key: user.userId,
      value: user.addressableName
    }));
    this.setState({ supportOwnerUserList:supportOwnerUserList });
  };

  onCreateLeadCancel = () => {
    this.setState({ createLeadMode: false, submitted: false, successMsg: null, errorList: null });
  };

  onCancelLeadUpdate = () => {
    this.setState({ leadUpdateMode: false, submitted: false, successMsg: null, errorList: null });
  };

  onCancelEmailToLead = () => {
    this.setState({ emailToLeadMode: false, submitted: false, successMsg: null, errorList: null });
  };

  onSendCustomEmailCancel = () => {
    this.setState({ sendCustomEmailMode: false, submitted: false, successMsg: null, errorList: null });
  };

  onCopyToClipboard = (text, result) => {
    this.setState({ copyToClipboardText: text });
    setTimeout(() => {
      this.setState({ copyToClipboardText: null });
    }, 3000);
  };

  onRefreshClick = (noBusy) => {
    let context = this.props.context;
    CacheManager.removeObject(CacheKeys.Leads(context.session.userId));
    CacheManager.removeObject(CacheKeys.SalesChannel());
    CacheManager.removeObject(CacheKeys.OwnerUsers());
    CacheManager.removeObject(CacheKeys.SupportOwnerUsers());
    if (noBusy === 'noBusy') {
      this.getAllLeads(context);
      this.getSalesChannels(context);
      this.getOwnerUsers(context);
      this.getSupportOwnerUsers(context);
    } else {
      this.setState({ leadList: null, errorList: null, salesChannelList: null, ownerUserList: null, supportOwnerUserList: null }, () => {
        this.getAllLeads(context);
        this.getSalesChannels(context);
        this.getOwnerUsers(context);
        this.getSupportOwnerUsers(context);
      });
    }
  };

  onLeadUpdateClick = (event) => {
    let leadId = event.currentTarget.getAttribute('data-lead-id');
    let selectedLead = this.state.leadList.filter(l => l.leadId === leadId)[0]
    this.setState({ leadUpdateMode: true, selectedLead: selectedLead })
  };

  onSendCustomEmailClick = (event) => {
    let leadId = event.currentTarget.getAttribute('data-lead-id');
    let selectedLead = this.state.leadList.filter(l => l.leadId === leadId)[0]
    this.setState({ sendCustomEmailMode: true, selectedLead: selectedLead })
  };
}

export default LeadListPageSf;
